export default __webpack_public_path__ + "static/media/citypost.502ff09c.png";